import _ from 'lodash';
import { ROW_TYPES } from '../Properties';
import { DEFAULT_INVALID_VALUE } from '../../../utilities/FormattingUtilities';

export function isBlank(value) {
    return _.isNil(value) || _.trim(value) === '';
}

export function isPresent(value) {
    return !_.isNil(value) || !_.trim(value) === '';
}

export function stringProperty(title, selector, renderer) {
    return {
        title,
        type: ROW_TYPES.FUNCTION,
        mapper: (data) => {
            const value = _.get(data, selector);
            if (isBlank(value)) return DEFAULT_INVALID_VALUE;
            return renderer ? renderer(value, selector) : value;
        },
    };
}

export function linkProperty(title, selector, page, filters, excludedFilters, renderer) {
    return {
        title,
        type: ROW_TYPES.FUNCTION,
        mapper: (data) => {
            const value = _.get(data, selector);
            if (isBlank(value)) return DEFAULT_INVALID_VALUE;
            return renderer(page, value, filters, excludedFilters);
        },
    };
}

export function listProperty(title, selector, renderer) {
    return {
        title,
        type: ROW_TYPES.FUNCTION,
        mapper: (data) => {
            const value = _.get(data, selector);
            if (!value?.length) return DEFAULT_INVALID_VALUE;
            return renderer(value, selector);
        },
    };
}

export function listLinkProperty(title, selector, filters, excludedFilters, renderer) {
    return {
        title,
        type: ROW_TYPES.FUNCTION,
        mapper: (data) => {
            const value = _.get(data, selector);
            if (!value?.length) return DEFAULT_INVALID_VALUE;
            return renderer(value, filters, excludedFilters);
        },
    };
}
